import { createContext, useContext, useState, useMemo, useCallback } from 'react';

const BookingContext = createContext();

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within BookingProvider');
  }
  return context;
};

export const BookingProvider = ({ children }) => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  const openBookingModal = useCallback(() => setIsBookingModalOpen(true), [setIsBookingModalOpen]);
  const closeBookingModal = useCallback(() => setIsBookingModalOpen(false), [setIsBookingModalOpen]);

  const value = useMemo(() => ({
    isBookingModalOpen,
    openBookingModal,
    closeBookingModal
  }), [isBookingModalOpen, openBookingModal, closeBookingModal]);

  return (
    <BookingContext.Provider value={value}>
      {children}
    </BookingContext.Provider>
  );
};
